<aside class="side-panel" [ngClass]="{'opened': opened}">
    <template #panelContainer></template>
    
    <!-- <app-quiz [dynamic]="true"></app-quiz> -->
</aside>